import React from 'react';
export function PainPoints() {
  const situations = ['Ponés el plato y escuchás "no me gusta" antes de que lo pruebe.', 'Terminás negociando cada bocado como si fuera un tratado de paz.', 'Cocinás una cosa para los chicos y otra para vos, todos los días.', 'Sentís culpa si no comen, y más culpa si cedés y hacés otra cosa.', 'Llegás a la noche agotada y sin idea de qué preparar.', '"Otra cosa no hay" se convirtió en tu frase más repetida.'];
  return <section className="py-16 md:py-24 bg-[#F6EEDC]" data-id="element-154">
      <div className="max-w-3xl mx-auto px-4" data-id="element-155">
        <div className="text-center mb-12" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2E2E2E] mb-4" data-id="element-157">
            ¿Esto te pasa?
          </h2>
        </div>

        <ul className="space-y-4 mb-12" data-id="element-158">
          {situations.map((situation, index) => <li key={index} className="flex items-start p-4 bg-[#FDFBF9] rounded-lg border border-[#2E2E2E]/5" data-id="element-159">
              <span className="w-2 h-2 bg-[#E0435A] rounded-full mr-4 mt-2 flex-shrink-0" data-id="element-160"></span>
              <p className="text-[#2E2E2E] text-base md:text-lg leading-relaxed" data-id="element-161">
                {situation}
              </p>
            </li>)}
        </ul>

        <div className="text-center" data-id="element-162">
          <p className="text-xl md:text-2xl font-semibold text-[#2E2E2E]" data-id="element-163">
            No te faltan recetas.{' '}
            <span className="text-[#0D3B66]" data-id="element-164">Te falta un sistema.</span>
          </p>
        </div>
      </div>
    </section>;
}